import Vue from "vue";
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyBToxYWsFfvEUwiQLeeLoXjWC7w_7QLwks'
})
